export default __webpack_public_path__ + "static/media/York University.6fc61f1e.jpg";